export default __webpack_public_path__ + "static/media/gameplay-city-new.cc93d763.png";